NetCode = function(options) {
    var self = this;

    self.initialize = function(options) {
        var NetCode = axios.create({
            //baseURL: options.api_base_path,
            timeout: options.timeout,
            headers: {'X-CSRF-TOKEN': options.csrf_token},
            maxContentLength: 20000
        });

        return NetCode;
    };

    self.getBaseApiRoute = function() {
        return '';
    }
};